import { StarterKitOptions } from '@tiptap/starter-kit';

import { HeadingOptions } from '@/ui/Editor/extensions';

export const defaultHeadingOptions: HeadingOptions = {
	levels: [
		{
			level: 1,
			className: 'text-2xl',
		},
		{
			level: 2,
			className: 'text-xl',
		},
		{
			level: 3,
			className: 'text-lg',
		},
		{
			level: 4,
			className: 'text-base',
		},
		{
			level: 5,
			className: 'text-sm',
		},
		{
			level: 6,
			className: 'text-xs',
		},
	],
	HTMLAttributes: {},
};

export const defaultBulletListOptions: StarterKitOptions['bulletList'] = {
	HTMLAttributes: {
		class: 'pl-10 list-disc',
	},
};

export const defaultOrderedListOptions: StarterKitOptions['orderedList'] = {
	HTMLAttributes: {
		class: 'pl-10 list-decimal',
	},
};

export const defaultBlockquoteOptions: StarterKitOptions['blockquote'] = {
	HTMLAttributes: {
		class: 'border-l-4 border-gray-500 pl-4 italic text-gray-700',
	},
};
